function syncFrame4ContentScale() {
  const frame = document.querySelector('#frame4');
  if (!frame) return;

  const viewportRatio = window.innerWidth / window.innerHeight;
  const isWideDesktop = window.innerWidth > 768 && viewportRatio > 2.05;
  const fitScale = isWideDesktop ? Math.min(1, 2 / viewportRatio) : 1;
  frame.style.setProperty('--frame4-content-scale', fitScale.toFixed(4));
}

function relayFrame4WheelToParent() {
  // Mobile dùng document flow bình thường; chỉ relay wheel cho Swiper desktop.
  if (window.parent === window || window.matchMedia('(orientation: portrait)').matches) return;

  document.addEventListener('wheel', (event) => {
    if (Math.abs(event.deltaY) < Math.abs(event.deltaX) || Math.abs(event.deltaY) < 20) return;

    event.preventDefault();
    window.parent.postMessage({ type: 'main-iframe-wheel', deltaY: event.deltaY }, '*');
  }, { passive: false });
}

window.addEventListener('load', function () {
  syncFrame4ContentScale();
  relayFrame4WheelToParent();

  const historyButton = document.querySelector('#frame4 .history-button');
  if (historyButton) {
    historyButton.addEventListener('click', () => {
      historyButton.classList.toggle('is-active');
      window.dispatchEvent(new CustomEvent('cake-shop:history'));
    });
  }

});

window.addEventListener('resize', syncFrame4ContentScale, { passive: true });
